import './styles/global.css';
import 'Utils/Polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { setUserPrivacyCookie } from 'Utils/Utils';
import { boundSetSource } from 'State/Tracking';
import { appInit } from 'State/GlobalActions';
import { getSessionCampaignTraits as setCampaignTraits } from 'Utils/Analytics/sessionCampaignTraits';
import { checkAndSetFNCCookie } from 'Utils/Analytics/setFNCCookie';
import { initRedfastActions } from 'Utils/Redfast';
import { App } from './App';
import { logger } from 'Utils/Logger';

const routes = GLOBAL_ROUTES;

//Note that these functions are running before appInit may update defaultConfig
boundSetSource(window);
setCampaignTraits();
checkAndSetFNCCookie();
setUserPrivacyCookie();
logger.init(); //init datadog

const container = document.getElementById('root');
const root = createRoot(container);

appInit().then(() => {
  root.render(
    <BrowserRouter>
      <App routes={routes} />
    </BrowserRouter>
  );
  initRedfastActions();
});
